import { ISocialPost, SocialPosts } from "@models/SocialPosts";
import { trimInnerHtml, trimLineBreaks } from "@helpers";

export enum FoodSocialSortFilterEnum {
    Engagement = 0,
    Newest = 1,
    Positive = 2,
    Negative = 3,
}

export const FOOD_SOCIAL_MINIMAL_FILTERS_FLAG = 'Snap Social Listening Minimal Filters';
export const FOOD_SOCIAL_CUSTOM_ASSOCIATION_FLAG = 'Social custom association';

export const FOOD_SOCIAL_COPY_DATA_CONFIG: Array<{
    key: keyof ISocialPost;
    title: string;
    valueFormatter?: (value: string) => string;
}> = [
    { key: 'source', title: 'Source' },
    { key: 'sentiment', title: 'Sentiment' },
    { key: 'engagement', title: 'Engagement Count' },
    { key: 'date', title: 'Date', valueFormatter: SocialPosts.formatDate },
    { key: 'text', title: 'Description', valueFormatter: (value) => trimLineBreaks(trimInnerHtml(value)) },
    { key: 'url', title: 'Post URL' },
];
